import { Compass, Sparkles, Flag } from "lucide-react";
import { Reveal } from "./motion";

export const PILLARS = [
  { key: "journey", n: "01", word: "Journey", icon: Compass, text: "Reflect on where you have been, where you are, and where you want to go." },
  { key: "empower", n: "02", word: "Empower", icon: Sparkles, text: "Build confidence, self-advocacy, independence, and awareness of support." },
  { key: "motivate", n: "03", word: "Motivate", icon: Flag, text: "Turn education and employment goals into practical next steps." },
];

const Tile = ({ p, className, delay }) => (
  <Reveal delay={delay} className={className}>
    <article className="group flex h-full flex-col justify-between rounded-3xl border border-[#D4AF37]/25 bg-[#12141C] p-8 transition-colors duration-500 hover:border-[#F3C649]/70 sm:p-10" data-testid={`pillar-${p.key}`}>
      <div className="flex items-center justify-between">
        <span className="font-mono-label text-sm text-[#F3C649]">{p.n}</span>
        <p.icon size={26} aria-hidden="true" className="text-[#F3C649] transition-transform duration-500 group-hover:rotate-12" />
      </div>
      <div className="mt-16">
        <h3 className="font-display text-5xl font-semibold sm:text-6xl">{p.word}</h3>
        <p className="mt-4 max-w-md text-base leading-relaxed text-[#C8C5BB]">{p.text}</p>
      </div>
    </article>
  </Reveal>
);

const Photo = ({ src, alt, className, delay }) => (
  <Reveal delay={delay} className={className}>
    <div className="group relative h-full min-h-[260px] overflow-hidden rounded-3xl border border-[#D4AF37]/25">
      <img src={src} alt={alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E]/60 to-transparent" />
    </div>
  </Reveal>
);

export const PillarBento = () => (
  <div className="grid gap-5 lg:grid-cols-12 lg:auto-rows-[minmax(320px,auto)]" data-testid="pillar-bento">
    <Tile p={PILLARS[0]} className="lg:col-span-5" delay={0} />
    <Photo src="/images/work.jpg" alt="Colleagues collaborating at an office desk, one working from a wheelchair" className="lg:col-span-7" delay={0.1} />
    <Photo src="/images/community.jpg" alt="Friends, two using wheelchairs, talking together around an outdoor café table" className="lg:col-span-4" delay={0} />
    <Tile p={PILLARS[1]} className="lg:col-span-4" delay={0.1} />
    <Tile p={PILLARS[2]} className="lg:col-span-4" delay={0.2} />
  </div>
);
